import { AxiosRequestConfig } from 'axios';
import { apiKey, privateApiKey } from './constants';
import MD5 from 'crypto-js/md5';

const generateAuthParams = (): AxiosRequestConfig['params'] => {
  const ts = new Date().getTime();

  const params = {
    apikey: apiKey,
    ts,
    hash: MD5(ts + privateApiKey + apiKey),
  };

  return params;
};

export default generateAuthParams;
